import { gql } from "apollo-boost";

export const CONSUMER_REQUEST_BOOKING_EXTENSION = gql`
  mutation consumerRequestBookingExtension($bookingId: ID!, $endDate: String!, $customerId: String, $businessCustomerId: String) {
    consumerRequestBookingExtension(bookingId: $bookingId, endDate: $endDate, customerId: $customerId, businessCustomerId: $businessCustomerId) {
      id
      referenceNumber
      extensionNumber
      status
      startDate
      endDate
      requestedBy
      conflictingBookingReference
      vehicleAvailableUntil
    }
  }
`;
